module.exports = __webpack_public_path__ + "img/hr-discounts.1b803368.png";